import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';
dayjs.extend(utc);
dayjs.extend(weekOfYear);

export default function buildCalendar(month) {
  const startDay = month.clone().startOf('month').startOf('week');
  const endDay = month.clone().endOf('month').endOf('week');
  let day = startDay.clone().subtract(1, 'day').startOf('day');

  const calendar = [];
  while (day.isBefore(endDay, 'day')) {
    calendar.push(
      Array(7)
        .fill(0)
        .map(() => {
          day = day.add(1, 'day');
          const newDay = dayjs
            .utc(day.format('YYYY-MM-DD'))
            .hour(21)
            .minute(0)
            .second(0)
            .millisecond(0)
            .local()
            .set('month', day.month())
            .set('date', day.date())
            .local();
          return newDay;
        }),
    );
  }

  return calendar;
}
